import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { ChevronDown } from 'lucide-react';
import { getRevenueTrend } from '../../../api-handle/revenue-analyticsApi';

const RevenueTrendChart = () => {
    const [data, setData] = useState({
        productTrend: [],
        classTrend: [],
        subscriptionTrend: [],
    });

    const [selectedTrend, setSelectedTrend] = useState('productTrend');
    const [mode, setMode] = useState('monthly');

    const trendLabels = {
        productTrend: 'Product',
        classTrend: 'Class',
        subscriptionTrend: 'Subscription',
    };

    // Simulate fetching API
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Simulate API response
                const response = await getRevenueTrend({
                    mode: mode
                })

                setData({
                    productTrend: Array.isArray(response.productTrend) ? response.productTrend : [],
                    classTrend: Array.isArray(response.classTrend) ? response.classTrend : [],
                    subscriptionTrend: Array.isArray(response.subscriptionTrend) ? response.subscriptionTrend : [],
                });
            } catch (error) {
                console.error('Failed to fetch trends:', error);
            }
        };

        fetchData();
    }, [mode]); // Add mode here if backend supports it

    const handleTrendChange = (e) => {
        setSelectedTrend(e.target.value);
    };

    const handleModeChange = (e) => {
        setMode(e.target.value);
    };

    const seriesData = data[selectedTrend] || [];
    const categories = seriesData.map((item) => item.date);
    const values = seriesData.map((item) => item.value);

    const chartOptions = {
        chart: {
            id: 'revenue-trend-chart',
            toolbar: { show: false },
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    fontSize: '12px',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 3,
        },
        colors: ['#33bdbf'], // Tailwind's indigo-500
        tooltip: {
            y: {
                formatter: (val) => `${val.toLocaleString()} KWD`,
            },
        },
        title: {
            text: `${trendLabels[selectedTrend]} Revenue Trend (${mode})`,
            align: 'left',
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#111827', // Tailwind text-black
            },
        },
    };

    return (
        <div
            style={{
                padding: "10px"
            }} className="bg-white shadow rounded-2xl p-6 w-full">
            {/* Filters */}
            <div
                className="revenue-trend-filters"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '1rem',
                    marginBottom: '1.5rem',
                    flexWrap: 'wrap', // optional: for better responsiveness
                }}
            >
                {/* Trend Dropdown */}
                <div style={{ position: 'relative' }}>
                    <select
                        value={selectedTrend}
                        onChange={handleTrendChange}
                        style={{
                            appearance: 'none',
                            width: '12rem',
                            padding: '0.5rem 1rem',
                            border: '1px solid #D1D5DB',
                            borderRadius: '0.5rem',
                            color: '#000',
                            backgroundColor: '#fff',
                        }}
                    >
                        {Object.entries(trendLabels).map(([key, label]) => (
                            <option key={key} value={key}>
                                {label} Trend
                            </option>
                        ))}
                    </select>
                    <ChevronDown
                        size={16}
                        style={{
                            position: 'absolute',
                            right: '0.75rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#6B7280',
                            pointerEvents: 'none',
                        }}
                    />
                </div>

                {/* Mode Dropdown */}
                <div style={{ position: 'relative' }}>
                    <select
                        value={mode}
                        onChange={handleModeChange}
                        style={{
                            appearance: 'none',
                            width: '12rem',
                            padding: '0.5rem 1rem',
                            border: '1px solid #D1D5DB',
                            borderRadius: '0.5rem',
                            color: '#000',
                            backgroundColor: '#fff',
                        }}
                    >
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                    </select>
                    <ChevronDown
                        size={16}
                        style={{
                            position: 'absolute',
                            right: '0.75rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#6B7280',
                            pointerEvents: 'none',
                        }}
                    />
                </div>
            </div>


            {/* Chart */}
            {seriesData.length > 0 ? (
                <Chart
                    options={chartOptions}
                    series={[{ name: 'Revenue', data: values }]}
                    type="line"
                    height={350}
                />
            ) : (
                <div className="text-center text-gray-500 py-12">No data available for this trend.</div>
            )}
        </div>
    );
};

export default RevenueTrendChart;
